export const ADD_MY_LIST_NAME = 'ADD_MY_LIST_NAME';
export const REMOVE_MY_LIST_NAME = 'REMOVE_MY_LIST_NAME';
export const CREATE_MY_LIST = 'CREATE_MY_LIST';
export const CREATE_MY_LIST_REQ_COMPLETED = 'CREATE_MY_LIST_REQ_COMPLETED';
export const CREATE_MY_LIST_SUCCESS = 'CREATE_MY_LIST_SUCCESS';
export const CREATE_MY_LIST_FAILURE = 'CREATE_MY_LIST_FAILURE';
export const TRACK_MY_LIST_CREATED = 'TRACK_MY_LIST_CREATED';
export const TRACK_MY_LIST_FORM_ERROR = 'TRACK_MY_LIST_FORM_ERROR';
